import { type IConfigurationCardEntry } from '../ConfigurationCardContext.tsx';

/**
 * Ritardo di attivazione per la PRIMA card: le card partono con scroll 0.
 * La barra subentra solo quando l'header è uscito del tutto dalla vista.
 */
const FIRST_CARD_ACTIVATION_OFFSET = 40;

/**
 * Indice della card il cui titolo è nascosto dallo scroll nella vista `dense`:
 * l'ultima card principale il cui top è salito fino al bordo superiore del
 * container, la barra non va mostrata, se nessun titolo è nascosto.
 */
export function findCurrentCardIndex(
  /** Card principali in ordine DOM (già filtrate: niente sub-card). */
  topLevel: IConfigurationCardEntry[],
  /** Container di scroll: il suo top è lo "zero" rispetto a cui si misurano le card. */
  scrollParent: HTMLElement,
): number {
  const containerTop = scrollParent.getBoundingClientRect().top;
  let current = -1;
  for (let i = 0; i < topLevel.length; i++) {
    const el = document.getElementById(topLevel[i].id);
    // Card non (ancora) nel DOM: la saltiamo senza interrompere la scansione.
    if (!el) continue;
    const relTop = el.getBoundingClientRect().top - containerTop;
    const threshold = i === 0 ? -FIRST_CARD_ACTIVATION_OFFSET : 1;
    if (relTop <= threshold) current = i;
    // Le card sono in ordine DOM: le successive stanno più in basso.
    else break;
  }
  return current;
}
